import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Event for subscription errors (components can listen to this)
export const subscriptionErrorEvent = new EventTarget();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    // Check for subscription warning header
    const warning = response.headers['x-subscription-warning'];
    if (warning) {
      subscriptionErrorEvent.dispatchEvent(new CustomEvent('warning', { 
        detail: { message: warning } 
      }));
    }
    return response;
  },
  (error) => {
    // Handle 401 - Unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    // Handle 403 - Subscription Required
    if (error.response?.status === 403) {
      const data = error.response.data;
      if (data?.error === 'subscription_required') {
        // Dispatch event for components to handle
        subscriptionErrorEvent.dispatchEvent(new CustomEvent('suspended', { 
          detail: data 
        }));
        
        // Store error in sessionStorage for redirect handling
        sessionStorage.setItem('subscription_error', JSON.stringify(data));
        
        // Redirect to billing page
        if (window.location.pathname !== '/billing' && 
            window.location.pathname !== '/billing/plans' &&
            window.location.pathname !== '/billing/update-payment') {
          window.location.href = '/account-suspended';
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;